module.exports = __webpack_public_path__ + "static/img/nxtgen-logo-2x.8a14c80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nxtgen-logo-2x.png
// module id = CATn
// module chunks = 1